import { createFileRoute, redirect } from "@tanstack/react-router"
import { RouteError } from "#/components/route-error"

export const Route = createFileRoute("/_authenticated/admin/tenants/$orgId/")({
	errorComponent: RouteError,
	beforeLoad: ({ params, context }) => {
		const roles = (context as { roles?: string[] }).roles ?? []
		const isOperator = roles.includes("platform_operator") || roles.includes("platform_admin")
		throw redirect({
			to: isOperator ? "/admin/tenants/$orgId/modules" : "/admin/tenants/$orgId/reference-data",
			params,
		})
	},
})
